import React from 'react'
import styled from 'styled-components'
import { WidgetProps } from '@rjsf/utils'

import { Button } from '../../../design-system/Button'
import { EditorWidget } from '../../../design-system/FeedbotRjsfForm/components/widgets'

export const TextAreaWidget: React.FC<WidgetProps> = ({ formContext, ...restProps }) => {
  const { name, onChange } = restProps
  return (
    <Content>
      <EditorWidget {...restProps} isWrapTextEnabled />
      <StyledButton
        label="Reset"
        minMaxSizes={{ minWidth: 100, maxWidth: 100, maxHeight: 36 }}
        onClick={() => onChange(formContext.initialFormData[name])}
      />
    </Content>
  )
}

const Content = styled.span`
  display: flex;
  flex-direction: row;
`

const StyledButton = styled(Button)`
  min-width: 100px;
  margin-left: 15px;
`
